import React, {useEffect, useRef, useState} from 'react'
import {NavLink, useLocation} from 'react-router-dom'
import {HotFormVacation, InfoVacation, JobsSlider, JobTitle, ListVacantion, WhyWeWork} from './index'

import link_image from '../../../images/job/link.svg'

import styles from './styles.module.scss'
import {toast} from 'react-toastify'
import axios from 'axios'
import smoothscroll from 'smoothscroll-polyfill'

const Jobs = ({filterVacation, setFilterVacation, setActiveForm, checkDomenNameState, ourRef, captchaSiteKey}) => {
	const [successForm, setSuccessForm] = useState(false)
	const [info, setInfo] = useState([])

	smoothscroll.polyfill()
	const location = useLocation()
	const formRef = useRef(null)
	const prevRoute = location?.state
	let vacationInfo = location?.state?.itemVacation

	// проверка доменного имени и вытягивание айдишника вакансии с него
	let url = document.location.pathname
	let idUrl = url.split('=')
	let _protocol = window.location.protocol

	// получение вакансии при открытии отдельного урла с карточкой
	const vacationUrl = async () => {
		try {
			if (checkDomenNameState) {
				const result = await axios({
					method: 'get',
					url: `${_protocol}//${checkDomenNameState}/api/v1/position/${idUrl[1]}/`
				})
				setInfo(result.data)
			}
		} catch (e) {
			toast.error('Ошибка загрузки вакансий')
		}
	}

	useEffect(() => {
		setSuccessForm(false)
		if (ourRef) {
			ourRef?.current.scrollIntoView()
		}

		if (!prevRoute || prevRoute === null) {
			vacationUrl()
		}
	}, [vacationInfo])

	const openFormRef = () => {
    console.log('click_otkliknutsya');
    // let _tmr = window._tmr || (window._tmr = []);
    // _tmr.push({ type: 'reachGoal', id: 3398932, goal: 'click_otkliknutsya'});
		formRef.current.scrollIntoView({behavior: 'smooth', block: 'start'})
	}

	const copyLinkBuffer = () => {
		navigator.clipboard.writeText(window.location.href).then(() => toast.success('Скопировано!'))
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.block_1}>
				<div className={styles.left}>
					<div className={styles.sticky_wrap}>
						<div className={styles.sticky_wrap_up}>
							<NavLink to={prevRoute ? prevRoute?.route : '/'} className={styles.left_retake_btn} state={prevRoute}>
								<span>&larr;</span> Назад к списку вакансий
							</NavLink>
							<p className={styles.left_title}>{vacationInfo ? vacationInfo?.positionName : info?.positionName}</p>
						</div>

						<div className={styles.left_success_btn}>
							<button onClick={openFormRef}>
								Откликнуться <span>→</span>
							</button>
							<div className='w-fit' onClick={copyLinkBuffer}>
								<img src={link_image} alt='link'/>
								Скопировать ссылку
							</div>
						</div>
					</div>
				</div>
				<div className={styles.right}>
					<JobTitle vacationInfo={vacationInfo} setInfo={setInfo} info={info}/>
					<InfoVacation vacationInfo={vacationInfo} info={info}/>
					<JobsSlider vacationInfo={vacationInfo} info={info}/>
					<WhyWeWork vacationInfo={vacationInfo} info={info}/>

					<div className={styles.hotForm}>
						<p ref={formRef} className={styles.wrapper_down_text_p}>
							Хочу работать в команде
						</p>

						{successForm && (
							<div className={styles.wrapper_total_right_success}>
								<p className={styles.wrapper_total_right_success_p1}>
									Спасибо за интерес <br/> к&nbsp;компании Generium!
								</p>
								<p>Мы свяжемся с вами в случае соответствия резюме требованиям вакансии.</p>
							</div>
						)}

						{!successForm && (
							<HotFormVacation
								checkDomenNameState={checkDomenNameState}
								vacationInfo={vacationInfo}
								info={info}
								setSuccessForm={setSuccessForm}
								setActiveForm={setActiveForm}
								captchaSiteKey={captchaSiteKey}
							/>
							)}
					</div>
				</div>
			</div>
		</div>
		)
}

export default Jobs
